import React, { useEffect } from "react";
import { FormControlLabel, Switch, Typography, Box } from "@mui/material";

const PublishToggle = ({ value, onChange, publishEnd }) => {
  // 日付だけを比較するために時刻を切り捨てる関数
  const getYmdDate = (date) =>
    new Date(date.getFullYear(), date.getMonth(), date.getDate());

  const now = getYmdDate(new Date());
  const end = publishEnd ? getYmdDate(new Date(publishEnd)) : null;

  const isWithinPeriod = end && now <= end;
  const isExpired = end && now > end;

  useEffect(() => {
    // 掲載期間が終了していたら自動OFFに
    if (isExpired && value) {
      onChange(false);
    }
  }, [isExpired, value, onChange]);

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          gap: 2,
          mb: 2,
        }}
      >
        {/* 公開設定ラベル */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Typography sx={{ fontSize: 14 }}>公開設定</Typography>
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{
              lineHeight: 1.5,
              verticalAlign: "middle",
            }}
          >
            ※掲載終了日までは切り替え可能です。公開にするとユーザーに表示されます。
          </Typography>
        </Box>

        {/* スイッチ ＋ ON/OFF表示 */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 2,
            px: 1.5,
            py: 1,
            border: "1px solid #e5e7eb",
            borderRadius: 2,
            backgroundColor: "#f9fafb",
            "&:hover": {
              backgroundColor: "#f3f4f6",
            },
          }}
        >
          <FormControlLabel
            control={
              <Switch
                checked={value}
                onChange={(e) => onChange(e.target.checked)}
                disabled={!isWithinPeriod}
                size="small"
              />
            }
            label="公開ステータス"
            labelPlacement="end"
            sx={{
              m: 0,
              "& .MuiTypography-root": { fontSize: 14 },
            }}
          />

          {/* ON/OFF 状態の表示 */}
          <Typography
            variant="body2"
            sx={{ color: value ? "blue" : "gray", fontWeight: "bold" }}
          >
            {value ? "公開中" : "非公開"}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default PublishToggle;
